module.exports = "/_next/static/images/img__teachers_right_bottom_desktop-1fb2df13188405425ac0d1024ef75480.png";